module.exports = __webpack_public_path__ + "img/lg_ring_y_0_1_0@2x.7ec43de2.png";